import { render, staticRenderFns } from "./ClientEdit_Addresses.vue?vue&type=template&id=7c09d3f2&"
import script from "./ClientEdit_Addresses.vue?vue&type=script&lang=js&"
export * from "./ClientEdit_Addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports